import { GiveAwayModel } from 'models';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import { platformStates } from 'redux/platformSlice';
import Typo from 'consts/typography';
import ConditionButton from 'components/Commons/ConditionButton';
import { showSuccessModal } from 'components/Modals/CommonModals';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import userApi from 'api/userApi';
import tbet_token_logo from 'assets/images/terabet_coin_logo.png';
import usd_logo from 'assets/images/usd-logo.png';
import { IMG_ALT } from 'consts/app';
import { setShowConfetti } from 'features/home/homeSlice';

interface GiveAwayMessageProps {
  message: GiveAwayModel;
}

const GiveAwayMessage: React.FunctionComponent<GiveAwayMessageProps> = ({ message }) => {
  const t = useAppTranslation();
  const platform = useAppSelector(platformStates);
  const dispatch = useAppDispatch();
  const { isDesktop, isLargeDesktop } = platform;
  const handleResponseError = useHandleResponseError();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleClaimGiveAway = async () => {
    setIsLoading(true);
    const { ok, body, error } = await userApi.usePromotion({
      promotionCode: message.promotionCode,
    });
    setIsLoading(false);
    if (ok && body) {
      showSuccessModal({
        title: t('event.claim.success.title'),
        content: t('event.claim.success.message'),
        onOk: () => {},
      });
      dispatch(setShowConfetti(true));
    }
    if (error) {
      handleResponseError({
        ...error,
        message:
          error.message === 'error.message.user.block-chat'
            ? 'error.message.user.block-chat'
            : error.message === 'error.promotion.used'
            ? 'error.promotion.already-giveaway'
            : 'error.promotion.disable-giveaway',
      });
    }
  };

  return (
    <div className="share-bet__message">
      <div className="share-bet__content give_away_content">
        {message.coinSymbol === 'USD' && <img src={usd_logo} alt={IMG_ALT} />}
        {message.coinSymbol === '$TBET' && <img src={tbet_token_logo} alt={IMG_ALT} />}
        <p>{t('chat.give-away.notice')}</p>
        <span>
          {t('chat.give-away.content')} <br /> {message.amount} {message.coinSymbol}
        </span>
        <span className="font-bold">{!!message.walletReceive ? message.walletReceive : 'BET'}</span>
        <ConditionButton
          onClick={handleClaimGiveAway}
          className={`follow-bet__btn ${isDesktop || isLargeDesktop ? Typo.p4 : Typo.p6}`}
          content={t('chat.give-away.get-reward')}
          testerCheck={true}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default GiveAwayMessage;
